// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import EntitySelectorDTO from './EntitySelectorDTO';

interface HelpPageDTO extends EntitySelectorDTO { 
  route: string | null;
  helpUrl: string | null;
}
const HelpPageDTO = {
  create: (initValues?: Partial<HelpPageDTO> | Record<string, unknown> | null) => {
    return Object.assign(EntitySelectorDTO.create(),
    {
      route: null,
      helpUrl: null,
    },
    initValues);
  }
};

export default HelpPageDTO;